const VideoTitle = ({ overview,title}) => {
  
  

  return (
    <div className=" absolute   bg-gradient-to-r  w-screen aspect-video">
      <div className="px-10 mt-[30%] sm:mt-[20%] md:mt-[19%] lg:mt-[20%] xl:w-[50%] ">
        <h1 className="text-2xl md:text-4xl text-white ">{title}</h1>
        <h1 className="hidden md:block md:w-3/5 lg:block lg:w-1/4 xl:w-2/4 text-white">{overview.split('.')[0]}</h1>
      <div className="flex  md:mt-1  lg:mt-10">
        <button className="text-2xl md:text-2xl border w-auto px-2 md:px-2 py-1 md:mx-2 bg-white text-black  shadow-2xl hover:opacity-75">▶️ Play</button>
        <button className="hidden md:block md:text-2xl border w-auto px-4 py-1 bg-white text-black  shadow-xl">ℹ️ More Info</button>
      </div>
      </div>
    </div>
  );
};
export default VideoTitle;
